export const getAuthUser = () => {
    if (!localStorage.getItem("user")) {
        return null;
    }

    const user: any = localStorage.getItem("user");

    return JSON.parse(user);
}

export const isLoggedIn = () => {
    return getAuthUser() !== null;
}

export const isUserAdmin = () => {
    const authUser = getAuthUser();

    if (!authUser) {
        return false;
    }

    return authUser.roles.includes("ROLE_ADMIN")
}